package com.exura.features.plandefinition.domain.model.element

import com.exura.features.plandefinition.domain.model.series.HourOfDay
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Represents a floating element that is not anchored to a specific day
 * but may have a deadline.
 * Generated from FloatingSeries.
 * Updated to implement SerializableDomainModel through BasePlanElement.
 */
data class FloatingElement(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val title: String,
    val instruction: String,
    val deadline: Int? = null,
    val exactTime: HourOfDay? = null,
    override val imageUrl: String? = null,
    override val durationInMinutes: Int = 5,
) : BasePlanElement(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    elementType = ElementType.FLOATING,
) {
    override val relativeDay: Int? = deadline
    override fun durationInDays(): Int {
        val minutesInDay = 24 * 60
        val minutes = durationInMinutes
        return (minutes + minutesInDay - 1) / minutesInDay
    }
}
